import { useState } from "react";
import { Box, Image } from "@chakra-ui/react";

const GenderImage = ({ voice, isDark }) => {
  const [imgError, setImgError] = useState(false);

  return !imgError ? (
    <Image
      src={voice?.avatar_url}
      alt={voice?.voice_name}
      boxSize="20px"
      borderRadius="full"
      mr={2}
      onError={() => setImgError(true)}
    />
  ) : (
    <Box
      boxSize="20px"
      borderRadius="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      mr={2}
      bg={isDark ? "gray.700" : "gray.300"}
      rounded="full"
      flexShrink={0}
    >
      {voice?.voice_name?.[0]?.toUpperCase()}
    </Box>
  );
};

export default GenderImage;
